import { role } from '@/controlles/auth'
import { bLock } from '@/components/blocks'

/*
 junior-manager - младший менеджер
 courier - курьер
 manager - менеджер
 senior-manager - старший менеджер
 storekeeper - кладовщик
 courier-delivery-dispatcher - диспетчер курьерский доставко
 trainee-salesman - продавец стажер
 sponsorship - спонсорство
 club-manager - менеджер клуба
 club-owner - представитель клуба
*/

const getMenuHeader = () => {
  const menuheader = [
    // { name: 'Главная', role: ['junior-manager', 'courier'], path: 'home',svg:null },
    { name: 'Профиль', role: ['junior-manager', 'courier', 'storekeeper', 'club-owner','club-manager'], path: 'user-profile', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <circle cx="12" cy="8" r="4" stroke="currentColor" fill="none"></circle>
                            <path d="M5 20V19C5 15.6863 7.68629 13 11 13H13C16.3137 13 19 15.6863 19 19V20" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>` },
    { name: 'Каталог', role: ['junior-manager'], path: 'catalog-index',svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M4 4H9V9H4V4Z" stroke="currentColor" fill="none"></path>
                            <path d="M15 4H20V9H15V4Z" stroke="currentColor" fill="none"></path>
                            <path d="M15 15H20V20H15V15Z" stroke="currentColor" fill="none"></path>
                            <path d="M4 15H9V20H4V15Z" stroke="currentColor" fill="none"></path>
                        </svg>` },
    { name: 'Остаток', role: ['storekeeper'], path: 'catalogostatok-index',svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="4" y="8" width="16" height="12" rx="1" stroke="currentColor"></rect>
                            <path d="M8 6V4H16V6" stroke="currentColor" stroke-linecap="round"></path>
                            <circle cx="12" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
                        </svg>` },
    { name: 'Скидки', role: ['junior-manager'], path: 'catalog-sale',svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M9 15L15 9" stroke="currentColor" stroke-linecap="round"></path>
                            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none"></circle>
                            <circle cx="15.5" cy="15.5" r="1.5" fill="currentColor" stroke="none"></circle>
                        </svg>` },
    
    { name: 'Менеджер', role: ['club-owner'], path: 'manager-view', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <circle cx="12" cy="8" r="3" stroke="currentColor" fill="none"></circle>
                            <path d="M6 21V18C6 15.2386 8.23858 13 11 13H13C15.7614 13 18 15.2386 18 18V21" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M18 6L20 8L18 10" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M6 10L4 8L6 6" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>` },
    
    { name: 'Аналитика', role: ['club-owner','club-manager'], path: 'analytics', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M3 17V20H21V17" stroke="currentColor" stroke-linejoin="round"></path>
                            <path d="M7 14L7 10" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M12 14L12 6" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M17 14L17 8" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M5 20L19 20" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>` },
    
    { name: 'Заказы', role: ['club-owner'], path: 'order-online', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M4 6H20" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M4 12H20" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M4 18H14" stroke="currentColor" stroke-linecap="round"></path>
                            <circle cx="18" cy="18" r="2.5" stroke="currentColor"></circle>
                            <path d="M20 20L22 22" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>` },
    
    { name: 'Перемещения', role: ['junior-manager','club-owner'], path: 'order-movements', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <path d="M8 7L16 7" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M8 12L16 12" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M8 17L13 17" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M18 4L22 7L18 10" stroke="currentColor" stroke-linecap="round"></path>
                            <path d="M6 20L2 17L6 14" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>` },
    { name: 'Склад', role: ['club-manager','club-owner'], path: 'catalog-mysklad', svg:`<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 4L4 20" stroke="currentColor" stroke-linecap="round"/>
  <path d="M20 4L20 20" stroke="currentColor" stroke-linecap="round"/>
  <path d="M4 8L20 8" stroke="currentColor" stroke-linecap="round"/>
  <path d="M4 14L20 14" stroke="currentColor" stroke-linecap="round"/>
  <path d="M4 20L20 20" stroke="currentColor" stroke-linecap="round"/>
  <path d="M7 4L7 20" stroke="currentColor" stroke-linecap="round"/>
  <path d="M17 4L17 20" stroke="currentColor" stroke-linecap="round"/>
</svg>` },
  { name: 'Инвентаризация', role: ['club-manager','club-owner','junior-manager'], path: 'catalog-invert', svg:`<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 50 50">
<path d="M 20 4 C 15.054688 4 11 8.054688 11 13 L 11 35.5625 L 5.71875 30.28125 L 4.28125 31.71875 L 11.28125 38.71875 L 12 39.40625 L 12.71875 38.71875 L 19.71875 31.71875 L 18.28125 30.28125 L 13 35.5625 L 13 13 C 13 9.144531 16.144531 6 20 6 L 31 6 L 31 4 Z M 38 10.59375 L 37.28125 11.28125 L 30.28125 18.28125 L 31.71875 19.71875 L 37 14.4375 L 37 37 C 37 40.855469 33.855469 44 30 44 L 19 44 L 19 46 L 30 46 C 34.945313 46 39 41.945313 39 37 L 39 14.4375 L 44.28125 19.71875 L 45.71875 18.28125 L 38.71875 11.28125 Z"></path>
</svg>` }
    
   // { name: 'Карта', role: ['courier'], path: 'couier-map', svg:null }
  ]
  
  return menuheader.filter(x => x.role.indexOf(role.value) !== -1)
}

const getMenuIndex = () => {
  const menuindex = [
    { name: 'Оформить заказ', role: ['junior-manager'], path: 'client-auth', class: 'button_light', query: {} },
    { name: 'Каталог', role: ['club-owner'], path: 'catalog-index', class: 'button_light', query: {} },
    { name: 'Оформить возврат', role: ['junior-manager'], path: 'client-auth', class: 'button_light', query: { type: 'return' } },
    { name: 'Собрать', role: ['storekeeper', 'junior-manager'], path: 'warehouse-collect', class: 'button_light', query: {} },
    { name: 'К отгрузке', role: ['storekeeper', 'junior-manager'], path: 'warehouse-issue', class: 'button_light', query: {} },
    { name: 'Возвраты', role: ['storekeeper', 'junior-manager'], path: 'warehouse-returnorder', class: 'button_light', query: {} },
   // { name: 'Создать возврат', role: ['storekeeper'], path: 'order-returnorder', class: 'button_light', query: {} },
    { name: 'Перемещения', role: ['storekeeper'], path: 'shop', class: 'button_light', query: {} },
    { name: 'Ожидает обеспечения', role: ['storekeeper', 'junior-manager'], path: 'warehouse-instok', class: 'button_light', query: {} },
   // { name: 'Поиск заказов', role: ['storekeeper'], class: 'button_light', path: 'order-search', okno: true, component: bLock().searchOrder },
    { name: 'К доставке', role: ['courier'], path: 'delivery-kdostavke', class: 'button_light', query: {} },
    { name: 'На доставку', role: ['courier'], path: 'delivery-nadostavku', class: 'button_light', query: {} },
    { name: 'Доставить', role: ['courier'], path: 'delivery-dostavit', class: 'button_light', query: {} },
    { name: 'Отчет', role: ['courier'], path: 'delivery-report', class: 'button_light', query: {} }
  ]
  return menuindex.filter(x => x.role.indexOf(role.value) !== -1)
}

const getMenuClient = () => {
  const menuclient = [
    { name: 'Профиль', role: ['junior-manager'], path: 'clientProfile' },
    { name: 'Заказы', role: ['junior-manager'], path: 'clientOrders' },
    { name: 'Заметки', role: ['junior-manager'], path: 'clientNotes' },
    { name: 'Клубы', role: ['junior-manager'], path: 'clientClubs' }
  ]
  return menuclient.filter(x => x.role.indexOf(role.value) !== -1)
}

export { getMenuHeader, getMenuIndex, getMenuClient }
